module.exports = __webpack_public_path__ + "img/pc_phone.a317b9e6.svg";